/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Reviews_TitleInputs */

const es_marketplace_seo_spain_reviews_title = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiniones de quienes ya navegaron con Zarpar`)
};

const gl_marketplace_seo_spain_reviews_title = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opinións de quen xa navegou con Zarpar`)
};

const en_marketplace_seo_spain_reviews_title = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews from Zarpar sailors`)
};

/**
* | output |
* | --- |
* | "Reviews from Zarpar sailors" |
*
* @param {Marketplace_Seo_Spain_Reviews_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_reviews_title = /** @type {((inputs?: Marketplace_Seo_Spain_Reviews_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Reviews_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_reviews_title(inputs)
	if (locale === "en") return en_marketplace_seo_spain_reviews_title(inputs)
	return es_marketplace_seo_spain_reviews_title(inputs)
});